import { OPERATORS_FILTERS } from "../../../shared/constants/GeneralConstants";
import { FILTER_DISPLAY } from "../../Dashboards/AdminDashboard/constants/AdminDashboardConstants";
import { SecondaryFilter } from "../../Dashboards/AdminDashboard/models/SecondaryFilter";

export const TEMPLATEPDF_DATA_EVENTS = {
  EDIT_DATA: "editData",
  DELETE_DATA: "deleteData",
  VIEW_DATA: "viewData",
  ASSIGN_SERVICE: "assignService",
  INFO_MODAL_TEMPLATE_CLOSE: "infoModalTemplateClose",
  PROFILE: "profile",
  DISABLE_DATA: "disableData"
};

export const TEMPLATEPDF_CONSTANTS = {
  PAGE_TITLE: "Plantillas PDF",
  PAGE_TITLE_SEARCH: "Consulta de plantillas PDF",
  ADD_TEMPLATEPDF: "Crear plantilla PDF",
  CANCEL_SAVE_TEMPLATEPDF: "Cancelar",
  EDIT_TEMPLATEPDF: "Editar plantilla PDF",

  REFERENCES_TEXTS: {
    CLOSE_MODAL: "closeModal",
    OPTIONS_CONTAINER: "optionsContainer",

    ADD_TEMPLATE: "addData",
    EDIT_TEMPLATE: "editData",
    SAVE_TEMPLATE: "saveData",
    EDIT_TITLE: "editTitle",
    NOT_SAVED_TEMPLATE: "La plantilla no fue creada",
    REQUIRE_NAME: "El nombre es requerido"
  },

  TEMPLATEPDF_FILTERS: {
    MAIN: {
      mainFilterKey: "all",
      mainFilterName: "Todos",
      avatar: "mdi-animation",
      secondaryFilters: [] as SecondaryFilter[],
      initial: true,
      placeholder:
        "Escriba el nombre de la plantilla o utiliza los filtros para agrupar información"
    },
    SECONDARY: {
      NAME: {
        name: "Nombre",
        placeholder: "Nombre de Plantilla PDF",
        key: "name",
        avatar: "mdi-form-textbox",
        type: "secondaryFilter",
        default: true,
        disabled: false,
        operators: OPERATORS_FILTERS,
        display: FILTER_DISPLAY.UNIQUE
      },
      TYPE: {
        name: "Tipo de lista",
        key: "type",
        avatar: "mdi-phone",
        type: "secondaryFilter",
        disabled: false,
        operators: OPERATORS_FILTERS,
        display: FILTER_DISPLAY.LIST,
        options: [] as {
          key: string;
          name: string;
        }[]
      },
      STATUS: {
        name: "Estado",
        placeholder: "Estado de Plantilla PDF",
        key: "state",
        avatar: "mdi-list-status",
        type: "secondaryFilter",
        disabled: false,
        operators: OPERATORS_FILTERS,
        display: FILTER_DISPLAY.LIST,
        options: [
          { name: "Activo", key: "Activo" },
          { name: "Inactivo", key: "Inactivo" }
        ]
      },
      CATEGORY: {
        name: "Categoria",
        key: "category",
        avatar: "mdi-shape",
        type: "secondaryFilter",
        disabled: false,
        operators: OPERATORS_FILTERS,
        display: FILTER_DISPLAY.LIST,
        options: [
          { name: "Habilitado", key: "Activo" },
          { name: "Deshabilitado", key: "Inactivo" }
        ]
      }
    }
  }
};

export const TEMPLATEPDF_MESSAGES = {
  SAVED_SUCCESSFULLY: "Se ha guardado la informacion de forma exitosa",
  EDIT_SUCCESSFULLY: "Plantilla modificada correctamente",
  DELETE_SUCCESSFULLY: "Plantilla PDF Eliminada correctamente",
  INACTIVATE_SUCCESSFULLY: "Plantilla PDF Inactivada correctamente",
  ACTIVE_SUCCESSFULLY: "Plantilla PDF activada correctamente",
  LABEL_REPEAT_NAME: "El titulo del label ya se encuantra en uso",
  SECTION_REPEAT_NAME:
    "El titulo para la secction del documento ya se encuntra en uso",
  ONE_SECTION_REQUIRED: "Se requiere como minimo una seccion para el documento",
  ERROR_GET_TEMPLATE_PDF: "Ocurrio un error al obtener la plantilla pdf"
};

export const LABELS_DATATYPE = ["Texto", "Numerico", "Booleano"];

export const LABELS_ADD_ACTIONPLAN_FORM = {
  ADD_LABEL_TITLE: "Añadir Labels",
  TITLE: "Titulo",
  DATA_TYPE: "Tipo de Dato",
  SECTION_TITLE_FORM: "Titulo de La seccion",
  IS_RANGED_VALUES: "Rango de valores",
  ADD_SECTION: "Añadir una nueva Sección",
  LABEL_DETAILS: "Valores Label ",
  URL_ICON: "Icono para la recomendacion",
  MAIN_COLOR: "Color Principal",
  WARNING_COLOR: "Color de la recomendacion",
  RECOMENDATION_INFO: "Infomación para sección de recomendaciones",
  LABELS_INFO: "Informacion de las Label",
  ACTION_PLAN_TEMPLATE_SWITCH: "Plantilla PDF Plan de acción",
  TEMPLATE_NAME: "Nombre de la plantilla"
};

export const EMIT_ACTION_PLAN_TEMPLATE_EVENTS = {
  ADD_LABEL: "addLabel",
  ADD_SECTION: "addSection",
  REMOVE_LABEL: "removeLabel",
  REMOVE_SECTION: "removeSection",
  CLOSE: "close",
  EDIT_SECTION: "editSection",
  CHANGE_TEMPLATE_TYPE: "changeType"
};

export const EMPTY_SECTION = {
  title: "",
  mainColor: "",
  recomendationColor: "",
  labels: [
    {
      title: "",
      valueType: ""
    },
    {
      title: "",
      valueType: ""
    }
  ],
  isRange: false,
  recomendationIcon: ""
};
export const COMPONENETS_IDS = {
  ADD_SECTION: "addSection",
  SHOW_SECTION: "showSection",
  ADD_LABEL: "addLabel"
};
export const WHITE_COLOR = "#FFFFFF";

export const PDFTEMPLATES_TYPES = {
  ACTION_PLAN: "ActionPlan"
};

export const TEMPLATE_PDF_ACCESS = {
  GET: "consultar plantillas PDF",
  POST: "crear plantillas PDF",
  PUT: "modificar plantillas PDF",
  DELETE: "eliminar plantillas PDF"
};
